import ProductFamily from "interfaces/ProductFamily";
import { enumFromString } from "utils";
import FileCategory from "interfaces/FileCategory";

export function organizeFileCategories(
    fileCategories: FileCategory[]
): FileCategory[] {
    const organizedCategories: FileCategory[] = [];
    const assetPackageFiles: FileCategory["files"] = [];

    // First pass: collect all asset package files and add non-asset packages to the result
    fileCategories.forEach((category) => {
        if (category.name.startsWith("asset_package_")) {
            // Collect all files from asset package categories
            assetPackageFiles.push(...category.files);
        } else {
            // Keep other categories as they are
            organizedCategories.push(category);
        }
    });

    // Only add asset packages category if there are any files
    if (assetPackageFiles.length > 0) {
        // Add a new combined category for all asset packages
        organizedCategories.push({
            name: "kanzi_asset_packages", // Use the enum value as the name
            files: assetPackageFiles,
        });
    }

    return organizedCategories;
}

export function getProductFamilyFromString(
    value: string
): ProductFamily | undefined {
    // First try direct match
    const directMatch = enumFromString(ProductFamily, value);
    if (directMatch !== undefined) {
        return directMatch;
    }

    // Then try pattern matching
    if (value.startsWith("asset_package_")) {
        return ProductFamily.KanziAssetPackages;
    }

    // Add more patterns as needed

    return undefined;
}
